import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05bb439a&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=05bb439a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb439a",
  null
  
)

export default component.exports